/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Documents from "./Documents";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";

type DocumentBoxProps = {
  product: AbstractCase;
  headline?: string;
};

const DocumentBox = ({ product, headline = "Meine Dokumente" }: DocumentBoxProps) => {
  if (!product.isCustomerDataCompleted) {
    return null;
  }

  return (
    <ContentBox headline={headline}>
      <Documents product={product} />
    </ContentBox>
  );
};

export default DocumentBox;
